module.exports = __webpack_public_path__ + "img/laying-classica-off.d065e03e.svg";